import dotenv from 'dotenv';
import { BaseLLM, BaseLLMConfig } from './base-llm';

dotenv.config({ quiet: true });

export interface GroqLLMConfig extends BaseLLMConfig {}

/**
 * GroqLLM class for handling AI-powered component generation and matching using Groq
 */
export class GroqLLM extends BaseLLM {
	constructor(config?: GroqLLMConfig) {
		super(config);
	}

	protected getDefaultModel(): string {
		return 'groq/openai/gpt-oss-120b';
	}

	protected getDefaultFastModel(): string {
		// Llama 3.1 8B is extremely fast and cheap on Groq
		return 'groq/llama-3.1-8b-instant';
	}

	protected getDefaultApiKey(): string | undefined {
		return process.env.GROQ_API_KEY;
	}

	protected getProviderName(): string {
		return 'Groq';
	}
}

// Export a singleton instance
export const groqLLM = new GroqLLM();
